import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import '../Style/Login.css';
import {API_URLS} from "../Utils/Constants"; // Reutilizamos el estilo de Login

const VoterRegistration = () => {
    const [name, setName] = useState('');
    const [dpi, setDpi] = useState('');
    const [email, setEmail] = useState('');
    const [birthday, setBirthday] = useState('');
    const [membershipNumber, setMemberShipNumber] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const isEmailValid = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const isPasswordValid = (password) => {
        const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;
        return regex.test(password);
    };


    const isAdult = (birthday) => {
        const birthDate = new Date(birthday);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            return age - 1 >= 18;
        }
        return age >= 18;
    };

    const handleRegister = async () => {
        setError('');

        if(membershipNumber.length !== 6){
            setError('El número de afiliación debe tener exactamente 6 caracteres.');
            return;
        }

        if (name.length < 3) {
            setError('El nombre debe tener al menos 3 caracteres.');
            return;
        }

        if (dpi.length !== 13) {
            setError('El DPI debe tener exactamente 13 caracteres.');
            return;
        }

        if (!isEmailValid(email)) {
            setError('El correo electrónico no es válido.');
            return;
        }

        if (!isAdult(birthday)) {
            setError('Debes ser mayor de 18 años para registrarte.');
            return;
        }

        if (!isPasswordValid(password)) {
            setError('La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }

        const formattedBirthday = birthday ? new Date(birthday).toISOString().split('T')[0] : '';

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            name,
            dpi,
            membership_number: membershipNumber,
            username: email,
            birthday: formattedBirthday,
            type: "VOTANTE",
            password,
        });

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
        };

        const url = `${API_URLS.BASE_PATH}/api/register`;

        try {
            const response = await fetch(url, requestOptions);

            if (response.ok) {
                const data = await response.json();
                navigate('/login');
            } else {
                const errorData = await response.json();
                setError(errorData.error || 'Hubo un error en el registro');
            }

        } catch (error) {
            console.error('Error durante el registro:', error);
            setError('Error al conectar con el servidor');
        }
    };

    return (
        <div className="login-container">
            <div className="login-content">
                <Card className="login-card shadow">
                    <Card.Body>
                        <Form>
                            <Form.Group className="mb-3" controlId="membershipNumber">
                                <Form.Label>Numero Colegiado</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ingresa tu numero de colegiado"
                                    value={membershipNumber}
                                    onChange={(e) => setMemberShipNumber(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label>Nombre Completo</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ingresa tu nombre"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="dpi">
                                <Form.Label>DPI</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ingresa tu DPI"
                                    value={dpi}
                                    onChange={(e) => setDpi(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Ingresa tu email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="birthday">
                                <Form.Label>Fecha de Nacimiento</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={birthday}
                                    onChange={(e) => setBirthday(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="password">
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Contraseña"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="confirmPassword">
                                <Form.Label>Confirmar Contraseña</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Confirma tu contraseña"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </Form.Group>

                            {error && <p className="text-danger">{error}</p>}

                            <Button variant="primary" onClick={handleRegister} className="w-100 mb-2">
                                Registrar Votante
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default VoterRegistration;
